import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { Label } from '../../ui/label';
import { Input } from '../../ui/input';
import { Checkbox } from '../../ui/checkbox';
import { Button } from '../../ui/button';
import { toast } from 'sonner';
import { LucideImage, LucideUpload, Trash2Icon } from 'lucide-react';
import { AvatarModal } from '../../../modals/avatar_modal';
import { updateAccount, uploadImage } from '../../../api/account';
import { Config } from '../../../utils';
import { trackView } from '../../analytics/track_view';
import { MixpanelEvents } from '../../analytics/mix_panel_events';
import { updateCrispProfile } from '../../../api/crisp';
import { updateStripeProfile } from '../../../api/stripe';
import { numberRegex, usaPhoneRegex } from '../../../helper/regex';
import { Loader } from '../../../ui_components/loader';
import Select from '../../elements/Select/Select';
import { ErrorInputPopUp } from '../../input_popups/error_input_popup';

type BusinessInfoProps = {
  activeTab: boolean;
  loading: boolean;
  disabled: boolean;
  accountId: any;
  formFields: any;
  accountIsOwner: boolean;
  accountIsAdmin: boolean;
  handleRefetchAccount?(): void;
};
type BillingFormType = {
  companyName: string;
  address: string;
  unitSuite: string;
  city: string;
  state: string;
  zipCode: string;
  email: string;
  phone: string;
};
type FacingFormType = {
  companyName: string;
  address: string;
  unitSuite: string;
  city: string;
  state: string;
  zipCode: string;
  email: string;
  phone: string;
};
type BillingFormTypeError = {
  companyName: {
    active: boolean;
    message: string;
  };
  address: {
    active: boolean;
    message: string;
  };
  unitSuite: {
    active: boolean;
    message: string;
  };
  city: {
    active: boolean;
    message: string;
  };
  state: {
    active: boolean;
    message: string;
  };
  zipCode: {
    active: boolean;
    message: string;
  };
  email: {
    active: boolean;
    message: string;
  };
  phone: {
    active: boolean;
    message: string;
  };
};
type FacingFormTypeError = {
  companyName: {
    active: boolean;
    message: string;
  };
  address: {
    active: boolean;
    message: string;
  };
  unitSuite: {
    active: boolean;
    message: string;
  };
  city: {
    active: boolean;
    message: string;
  };
  state: {
    active: boolean;
    message: string;
  };
  zipCode: {
    active: boolean;
    message: string;
  };
  email: {
    active: boolean;
    message: string;
  };
  phone: {
    active: boolean;
    message: string;
  };
};

let initialBillingForm = {
  companyName: '',
  address: '',
  unitSuite: '',
  city: '',
  state: '',
  zipCode: '',
  email: '',
  phone: '',
};

let initialFacingForm = {
  companyName: '',
  address: '',
  unitSuite: '',
  city: '',
  state: '',
  zipCode: '',
  email: '',
  phone: '',
};

let initialBillingFormError = {
  companyName: {
    active: false,
    message: '',
  },
  address: {
    active: false,
    message: '',
  },
  unitSuite: {
    active: false,
    message: '',
  },
  city: {
    active: false,
    message: '',
  },
  state: {
    active: false,
    message: '',
  },
  zipCode: {
    active: false,
    message: '',
  },
  email: {
    active: false,
    message: '',
  },
  phone: {
    active: false,
    message: '',
  },
};

let initialFacingFormError = {
  companyName: {
    active: false,
    message: '',
  },
  address: {
    active: false,
    message: '',
  },
  unitSuite: {
    active: false,
    message: '',
  },
  city: {
    active: false,
    message: '',
  },
  state: {
    active: false,
    message: '',
  },
  zipCode: {
    active: false,
    message: '',
  },
  email: {
    active: false,
    message: '',
  },
  phone: {
    active: false,
    message: '',
  },
};

let statesList = [
  { id: 1, label: 'AL', value: 'AL' },
  { id: 2, label: 'AK', value: 'AK' },
  { id: 3, label: 'AZ', value: 'AZ' },
  { id: 4, label: 'AR', value: 'AR' },
  { id: 5, label: 'CA', value: 'CA' },
  { id: 6, label: 'CO', value: 'CO' },
  { id: 7, label: 'CT', value: 'CT' },
  { id: 8, label: 'DE', value: 'DE' },
  { id: 9, label: 'DC', value: 'DC' },
  { id: 10, label: 'DR', value: 'DR' },
  { id: 11, label: 'FL', value: 'FL' },
  { id: 12, label: 'GA', value: 'GA' },
  { id: 13, label: 'HI', value: 'HI' },
  { id: 14, label: 'ID', value: 'ID' },
  { id: 15, label: 'IL', value: 'IL' },
  { id: 16, label: 'IN', value: 'IN' },
  { id: 17, label: 'IA', value: 'IA' },
  { id: 18, label: 'KS', value: 'KS' },
  { id: 19, label: 'KY', value: 'KY' },
  { id: 20, label: 'LA', value: 'LA' },
  { id: 21, label: 'ME', value: 'ME' },
  { id: 22, label: 'MT', value: 'MT' },
  { id: 23, label: 'NE', value: 'NE' },
  { id: 24, label: 'NV', value: 'NV' },
  { id: 25, label: 'NH', value: 'NH' },
  { id: 26, label: 'NJ', value: 'NJ' },
  { id: 27, label: 'NM', value: 'NM' },
  { id: 28, label: 'NY', value: 'NY' },
  { id: 29, label: 'NC', value: 'NC' },
  { id: 30, label: 'ND', value: 'ND' },
  { id: 31, label: 'OH', value: 'OH' },
  { id: 32, label: 'OK', value: 'OK' },
  { id: 33, label: 'OR', value: 'OR' },
  { id: 34, label: 'MD', value: 'MD' },
  { id: 35, label: 'MA', value: 'MA' },
  { id: 36, label: 'MI', value: 'MI' },
  { id: 37, label: 'MN', value: 'MN' },
  { id: 38, label: 'MS', value: 'MS' },
  { id: 39, label: 'MO', value: 'MO' },
  { id: 40, label: 'PA', value: 'PA' },
  { id: 41, label: 'RI', value: 'RI' },
  { id: 42, label: 'SC', value: 'SC' },
  { id: 43, label: 'SD', value: 'SD' },
  { id: 44, label: 'TN', value: 'TN' },
  { id: 45, label: 'TX', value: 'TX' },
  { id: 46, label: 'UT', value: 'UT' },
  { id: 47, label: 'VT', value: 'VT' },
  { id: 48, label: 'VA', value: 'VA' },
  { id: 49, label: 'WA', value: 'WA' },
  { id: 50, label: 'WV', value: 'WV' },
  { id: 51, label: 'WI', value: 'WI' },
  { id: 52, label: 'WY', value: 'WY' },
];

// PAGE
const BusinessInfo = (props: BusinessInfoProps) => {
  const {
    loading = false,
    disabled = false,
    accountId,
    formFields,
    activeTab,
    accountIsOwner,
    accountIsAdmin,
    handleRefetchAccount,
  } = props;
  const billingCompanyRef = useRef<any>(null);
  const billingEmailRef = useRef<any>(null);
  const billingPhoneRef = useRef<any>(null);
  const facingCompanyRef = useRef<any>(null);

  const [billingForm, setBillingForm] = useState<BillingFormType>({
    ...initialBillingForm,
    ...(formFields?.billingInfo || {}),
  });
  const [billingFormError, setBillingFormError] =
    useState<BillingFormTypeError>(initialBillingFormError);
  const [facingForm, setFacingForm] = useState<FacingFormType>({
    ...initialFacingForm,
    ...(formFields?.clientFacingInfo || {}),
  });
  const [facingFormError, setFacingFormError] =
    useState<FacingFormTypeError>(initialFacingFormError);
  const [sameAsBilling, setSameAsBilling] = useState<boolean>(false);
  const [imageModalOpen, setImageModalOpen] = useState<boolean>(false);
  const [avatarId, setAvatarId] = useState<string | null | undefined>('');
  const [saving, setSaving] = useState<boolean>(false);

  useEffect(() => {
    setBillingForm((prev) => ({ ...prev, ...formFields?.billingInfo }));
    setFacingForm((prev) => ({ ...prev, ...formFields?.clientFacingInfo }));
    setSameAsBilling(formFields?.sameAsBilling || false);
    setAvatarId(formFields?.avatarId || '');
  }, [formFields?.billingInfo, formFields?.clientFacingInfo]);

  const handleSaving = (val: boolean) => {
    setSaving(val);
  };

  const handleSameAsBilling = (val: any) => {
    setSameAsBilling(val);
    if (val) {
      setFacingForm((prev) => ({ ...prev, ...billingForm }));
      setFacingFormError(initialFacingFormError);
    }
  };

  const handleCustomBillingState = (val: any) => {
    setBillingForm((prev) => {
      return { ...prev, state: val || '' };
    });
    setBillingFormError((prev) => {
      return { ...prev, state: { active: false, message: '' } };
    });
    if (sameAsBilling) {
      setFacingForm((prev) => {
        return { ...prev, state: val || '' };
      });
      setFacingFormError((prev) => {
        return { ...prev, state: { active: false, message: '' } };
      });
    }
  };

  const handleCustomFacingState = (val: any) => {
    setFacingForm((prev) => {
      return { ...prev, state: val || '' };
    });
  };

  const handleSelectFacingState = (item: any) => {
    setFacingForm((prev) => {
      return { ...prev, state: item?.value || item?.label || '' };
    });
  };

  const handleSelectBillingState = (item: any) => {
    setBillingForm((prev) => {
      return { ...prev, state: item?.value || item?.label || '' };
    });
    setBillingFormError((prev) => {
      return { ...prev, state: { active: false, message: '' } };
    });
    if (sameAsBilling) {
      setFacingForm((prev) => {
        return { ...prev, state: item?.value || item?.label || '' };
      });
      setFacingFormError((prev) => {
        return { ...prev, state: { active: false, message: '' } };
      });
    }
  };

  const handleBillingForm = (e: ChangeEvent<any>) => {
    let { name, value } = e.target;

    if (name === 'zipCode' && value && !numberRegex.test(value)) {
      return;
    }
    if (name === 'phone' && value && !usaPhoneRegex.test(value)) {
      return;
    }

    setBillingForm((prev) => {
      return { ...prev, [name]: value };
    });
    setBillingFormError((prev) => {
      return { ...prev, [name]: { active: false, message: '' } };
    });

    if (sameAsBilling) {
      setFacingForm((prev) => {
        return { ...prev, [name]: value };
      });
      setFacingFormError((prev) => {
        return { ...prev, [name]: { active: false, message: '' } };
      });
    }
  };

  const handleFacingForm = (e: ChangeEvent<any>) => {
    let { name, value } = e.target;

    if (name === 'zipCode' && value && !numberRegex.test(value)) {
      return;
    }

    setFacingForm((prev) => {
      return { ...prev, [name]: value };
    });
    setFacingFormError((prev) => {
      return { ...prev, [name]: { active: false, message: '' } };
    });
  };

  const handleAvatarModal = (val: boolean) => {
    setImageModalOpen(val);
  };

  const saveAvatarImage = async (file: File) => {
    if (disabled) {
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('accountId', accountId.toString());
    formData.append('fileStoreUrl', Config.fileStoreUrl);
    const res = await uploadImage(formData);
    if (res.error) {
      throw new Error(res.message);
    }

    const res1 = await updateAccount({
      accountId: accountId,
      targetAccountId: accountId,
      avatarId: res.url,
    });

    trackView(MixpanelEvents.UPLOAD_COMPANY_LOGO);

    if (res1.error) {
      if (res1.error && res1.message) {
        throw new Error(res1.message);
      }
    } else {
      handleAvatarModal(false);
      setAvatarId(res.url);
      toast('Logo uploaded', {
        description: 'Your company logo has been updated.',
      });
      if (handleRefetchAccount) handleRefetchAccount();
    }
  };

  const deleteAvatarImage = async () => {
    if (disabled) {
      return;
    }

    handleSaving(true);

    const res = await updateAccount({
      accountId: accountId,
      targetAccountId: accountId,
      avatarId: null,
    });

    if (res.error) {
      handleSaving(false);
      if (res.message && res.error) {
        throw new Error(res.message);
      }
    } else {
      setAvatarId(null);
      toast('Logo removed');
      if (handleRefetchAccount) handleRefetchAccount();
      setTimeout(() => {
        handleSaving(false);
      }, 1000);
    }
  };

  const handleResetAllErrors = () => {
    setBillingFormError(initialBillingFormError);
    setFacingFormError(initialFacingFormError);
  };

  const handleValidateBillingTab = (fields: string) => {
    if (fields === 'billing') {
      let validators = {
        companyName: (v: any) => {
          if (!v.trim()) return 'Please fill out this field';
          return '';
        },
        email: (v: any) => {
          if (!v.trim()) return 'Please fill out this field';
          if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v)) return 'Invalid email';
          return '';
        },
        phone: (v: any) => {
          if (!v.trim()) return 'Please fill out this field';
          return '';
        },
      };

      let nextErrors: any = {};

      for (const key of Object.keys(validators)) {
        const message = validators[key](billingForm?.[key]);
        nextErrors[key] = { active: !!message, message: message };
      }

      setBillingFormError((prev) => ({ ...prev, ...nextErrors }));
      return Object.values(nextErrors).every((err: any) => !err.active);
    } else if (fields === 'facing') {
      let validators = {
        companyName: (v: any) => {
          if (!v.trim()) return 'Please fill out this field';
          return '';
        },
      };

      let nextErrors: any = {};

      for (const key of Object.keys(validators)) {
        const message = validators[key](facingForm?.[key]);
        nextErrors[key] = { active: !!message, message: message };
      }

      setFacingFormError((prev) => ({ ...prev, ...nextErrors }));
      return Object.values(nextErrors).every((err: any) => !err.active);
    }
    return true;
  };

  const handleSaveBillingTab = async () => {
    if (disabled) return;

    const validate = handleValidateBillingTab('billing');
    let validateFacing = true;

    if (!sameAsBilling) {
      validateFacing = handleValidateBillingTab('facing');
    }
    if (!validate || !validateFacing) {
      console.error('Form is not valid, please check all required fields.');
      return;
    }

    handleResetAllErrors();
    handleSaving(true);

    const res = await updateAccount({
      accountId: accountId,
      targetAccountId: accountId,
      billingInfo: billingForm,
      clientFacingInfo: facingForm,
      sameAsBilling: sameAsBilling,
      avatarId: avatarId,
    });
    if (res.error) {
      handleSaving(false);
      if (res.message === 'ValidationError') {
        throw new Error(res.message);
      }
    } else {
      try {
        await updateCrispProfile(accountId, billingForm);
      } catch {}

      try {
        await updateStripeProfile(accountId, billingForm);
      } catch {}

      toast('Settings saved', {
        description: 'Account settings have been updated.',
      });
      if (handleRefetchAccount) handleRefetchAccount();
      setTimeout(() => {
        handleSaving(false);
      }, 1000);
    }
  };

  return (
    <div className={`space-y-6 ${activeTab ? 'block' : 'hidden'}`}>
      {!accountIsOwner && !accountIsAdmin ? (
        <>
          {Object.values(billingForm)?.every((v) => !v?.trim()) &&
            Object.values(facingForm)?.every((v) => !v?.trim()) && (
              <div className="text-sm text-muted-foreground bg-muted/80 border border-border rounded-md px-4 py-3">
                No business information has been configured yet. Contact your account owner or admin
                to set this up.
              </div>
            )}

          {avatarId && (
            <div className="space-y-4 p-4 bg-muted/50 rounded-lg">
              <h3 className="m-0 text-[16px] font-semibold text-foreground">Company Logo</h3>
              <div className="flex justify-center">
                <div className="w-32 h-32 border-2 border-border rounded-lg bg-background flex items-center justify-center overflow-hidden">
                  <img
                    className="max-w-full max-h-full object-contain"
                    src={`${Config.fileStoreUrl}${avatarId}`}
                  />
                </div>
              </div>
            </div>
          )}

          {Object?.values(billingForm)?.some((v) => v?.trim()) && (
            <div className="space-y-3 p-4 bg-muted/50 rounded-lg">
              <div>
                <h3 className="m-0 text-[16px]  font-semibold text-foreground">
                  Billing Information
                </h3>
                <p className="text-xs text-muted-foreground">Used for QUIPA Billing</p>
              </div>

              <div className="space-y-1 text-sm text-foreground">
                <p className="font-medium">{billingForm?.companyName || ''}</p>
                <p>
                  {[billingForm?.address, billingForm?.unitSuite]?.filter((v) => v)?.join(', ')}
                </p>
                <p>
                  {[billingForm?.city, billingForm?.state]?.filter((v) => v)?.join(', ')}{' '}
                  {billingForm?.zipCode || ''}
                </p>
                <p>{billingForm?.email || ''}</p>
                <p>{billingForm?.phone || ''}</p>
              </div>
            </div>
          )}

          {Object?.values(facingForm)?.some((v) => v?.trim()) && (
            <div className="space-y-3 p-4 bg-muted/50 rounded-lg">
              <div>
                <h3 className="m-0 text-[16px] font-semibold text-foreground">
                  External Facing Information
                </h3>
                <p className="text-xs text-muted-foreground">
                  Used for Estimates, Invoices, POs, Work Orders and other documents
                </p>
              </div>

              <div className="space-y-1 text-sm text-foreground">
                <p className="font-medium">{facingForm?.companyName}</p>
                <p>{[facingForm?.address, facingForm?.unitSuite]?.filter((v) => v)?.join(', ')}</p>
                <p>
                  {[facingForm?.city, facingForm?.state]?.filter((v) => v)?.join(', ')}{' '}
                  {facingForm?.zipCode || ''}
                </p>
                <p>{facingForm?.email || ''}</p>
                <p>{facingForm?.phone || ''}</p>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          {/* Logo */}
          <div className="space-y-4 p-[16px] bg-muted/50 rounded-lg">
            <div>
              <h3 className="text-[16px] m-0 font-semibold text-foreground">Company Logo</h3>
              <p className="text-xs text-muted-foreground">
                Will be used on PDFs, invoices, work orders and other documents.
              </p>
            </div>

            <div className="flex flex-col items-center gap-3">
              <div className="w-32 h-32 border-2 border-border rounded-lg bg-background flex items-center justify-center overflow-hidden">
                {avatarId ? (
                  <img
                    alt="Account Image"
                    className="max-w-full max-h-full object-contain"
                    src={`${Config.fileStoreUrl}${avatarId}`}
                  />
                ) : (
                  <div className="flex flex-col items-center gap-1 text-muted-foreground">
                    <LucideImage className="lucide lucide-image h-10 w-10 " />
                    <span className="text-xs font-medium">Logo Here</span>
                  </div>
                )}
              </div>

              <div className="flex items-center gap-2">
                <Button
                  data-qa={`account_image_upload_button`}
                  disabled={disabled || saving}
                  onClick={() => handleAvatarModal(true)}
                  variant={'outline'}
                  type="button"
                  className="font-medium"
                >
                  {!avatarId && <LucideUpload className="lucide lucide-upload h-4 w-4 mr-2" />}
                  {avatarId ? 'Replace Image' : 'Upload'}
                </Button>

                {avatarId && (
                  <Button
                    disabled={disabled || saving}
                    data-qa={`account_image_delete_button`}
                    variant={'trash-button'}
                    onClick={deleteAvatarImage}
                    type="button"
                  >
                    <Trash2Icon className="w-[16px] h-[16px]" />
                  </Button>
                )}
              </div>
            </div>
          </div>
          {/* Billing Information */}
          <div className="space-y-4 p-[16px] bg-muted/50 rounded-lg">
            <div>
              <h3 className="text-[16px] m-0 font-semibold text-foreground">Billing Information</h3>
              <p className="text-xs text-muted-foreground">Used for QUIPA Billing</p>
            </div>

            <div className="space-y-2">
              <Label htmlFor="companyName">
                Company Name <span className="text-destructive">*</span>
              </Label>
              <div ref={billingCompanyRef} className="relative w-full">
                <Input
                  data-qa={`billing_form_company_name_input_field`}
                  id="companyName"
                  name="companyName"
                  disabled={disabled || saving}
                  value={billingForm.companyName}
                  onChange={handleBillingForm}
                  className={`${billingFormError?.companyName?.active ? 'bg-errorBg text-error border-error' : ''}`}
                />
                <ErrorInputPopUp
                  anchorRef={billingCompanyRef}
                  active={billingFormError?.companyName?.active}
                  message={billingFormError?.companyName?.message}
                  position="top-center"
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="address">Address</Label>
              <Input
                data-qa={`billing_form_address_input_field`}
                id="address"
                name="address"
                disabled={disabled || saving}
                value={billingForm.address}
                onChange={handleBillingForm}
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="unitSuite">Suite / Unit</Label>
              <Input
                data-qa={`billing_form_unit_suite_input_field`}
                id="unitSuite"
                name="unitSuite"
                disabled={disabled || saving}
                value={billingForm.unitSuite}
                onChange={handleBillingForm}
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="city">City</Label>
              <Input
                data-qa={`billing_form_city_input_field`}
                id="city"
                name="city"
                disabled={disabled || saving}
                value={billingForm.city}
                onChange={handleBillingForm}
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="state">State</Label>
                <Select
                  dataQa={`billing_form_state_select_field`}
                  mode={'search'}
                  disabled={disabled || saving}
                  value={billingForm.state}
                  items={statesList}
                  onChange={handleCustomBillingState}
                  onSelect={handleSelectBillingState}
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="zipCode">Zip</Label>
                <Input
                  data-qa={`billing_form_zip_input_field`}
                  id="zipCode"
                  name="zipCode"
                  disabled={disabled || saving}
                  value={billingForm.zipCode}
                  onChange={handleBillingForm}
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="email">
                Email <span className="text-destructive">*</span>
              </Label>
              <div ref={billingEmailRef} className="relative w-full">
                <Input
                  data-qa={`billing_form_email_input_field`}
                  id="email"
                  name="email"
                  disabled={disabled || saving}
                  value={billingForm.email}
                  onChange={handleBillingForm}
                  className={`${billingFormError?.email?.active ? 'bg-errorBg text-error border-error' : ''}`}
                />
                <ErrorInputPopUp
                  anchorRef={billingEmailRef}
                  active={billingFormError?.email?.active}
                  message={billingFormError?.email?.message}
                  position="top-center"
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="phone">
                Phone <span className="text-destructive">*</span>
              </Label>
              <div ref={billingPhoneRef} className="relative w-full">
                <Input
                  data-qa={`billing_form_phone_input_field`}
                  id="phone"
                  name="phone"
                  disabled={disabled || saving}
                  value={billingForm.phone}
                  onChange={handleBillingForm}
                  className={`${billingFormError?.phone?.active ? 'bg-errorBg text-error border-error' : ''}`}
                />
                <ErrorInputPopUp
                  anchorRef={billingPhoneRef}
                  active={billingFormError?.phone?.active}
                  message={billingFormError?.phone?.message}
                  position="top-center"
                />
              </div>
            </div>
          </div>
          {/* External Facing Information */}
          <div className="space-y-4 p-[16px] bg-muted/50 rounded-lg">
            <div>
              <h3 className="m-0 text-[16px] font-semibold text-foreground">
                External Facing Information
              </h3>
              <p className="text-xs text-muted-foreground">
                Used for Estimates, Invoices, POs, Work Orders and other documents
              </p>
            </div>

            <div className="flex items-center space-x-2">
              <Checkbox
                data-qa={`same_as_billing_checkbox`}
                className="border-primary"
                checked={sameAsBilling}
                disabled={disabled || saving}
                onCheckedChange={(val) => handleSameAsBilling(val)}
                id="sameAsBilling"
              />
              <Label className="cursor-pointer" htmlFor="sameAsBilling">
                Same as Billing
              </Label>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="companyNameFacing">
                  Company Name <span className="text-destructive">*</span>
                </Label>
                <div ref={facingCompanyRef} className="relative w-full">
                  <Input
                    data-qa={`facing_form_company_name_input_field`}
                    id="companyNameFacing"
                    name="companyName"
                    disabled={disabled || sameAsBilling || saving}
                    value={facingForm.companyName}
                    onChange={handleFacingForm}
                    className={`${facingFormError?.companyName?.active ? 'bg-errorBg text-error border-error' : ''}`}
                  />
                  <ErrorInputPopUp
                    anchorRef={facingCompanyRef}
                    active={facingFormError?.companyName?.active}
                    message={facingFormError?.companyName?.message}
                    position="top-center"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="addressFacing">Address</Label>
                <Input
                  data-qa={`facing_form_address_input_field`}
                  id="addressFacing"
                  name="address"
                  disabled={disabled || sameAsBilling || saving}
                  value={facingForm.address}
                  onChange={handleFacingForm}
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="unitSuiteFacing">Suite / Unit</Label>
                <Input
                  data-qa={`facing_form_unit_suite_input_field`}
                  id="unitSuiteFacing"
                  name="unitSuite"
                  disabled={disabled || sameAsBilling || saving}
                  value={facingForm.unitSuite}
                  onChange={handleFacingForm}
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="cityFacing">City</Label>
                <Input
                  data-qa={`facing_form_city_input_field`}
                  id="cityFacing"
                  name="city"
                  disabled={disabled || sameAsBilling || saving}
                  value={facingForm.city}
                  onChange={handleFacingForm}
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="stateFacing">State</Label>
                <Select
                  dataQa={`facing_form_state_select_field`}
                  mode={'search'}
                  disabled={disabled || sameAsBilling || saving}
                  value={facingForm.state}
                  items={statesList}
                  onChange={handleCustomFacingState}
                  onSelect={handleSelectFacingState}
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="zipCodeFacing">Zip</Label>
                <Input
                  data-qa={`facing_form_zip_input_field`}
                  id="zipCodeFacing"
                  name="zipCode"
                  disabled={disabled || sameAsBilling || saving}
                  value={facingForm.zipCode}
                  onChange={handleFacingForm}
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="emailFacing">Email</Label>
                <Input
                  data-qa={`facing_form_email_input_field`}
                  id="emailFacing"
                  name="email"
                  disabled={disabled || sameAsBilling || saving}
                  value={facingForm.email}
                  onChange={handleFacingForm}
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="phoneFacing">Phone</Label>
                <Input
                  data-qa={`facing_form_phone_input_field`}
                  id="phoneFacing"
                  name="phone"
                  disabled={disabled || sameAsBilling || saving}
                  value={facingForm.phone}
                  onChange={handleFacingForm}
                />
              </div>
            </div>
          </div>

          {/* Actions */}
          {!disabled && (
            <div className="flex justify-end">
              <Button
                data-qa={`save_business_tab_button`}
                disabled={disabled || saving}
                onClick={() => handleSaveBillingTab()}
                type="button"
              >
                {saving ? 'Saving...' : 'Save Settings'}
              </Button>
            </div>
          )}
        </>
      )}

      <AvatarModal
        uiActive={imageModalOpen}
        uiOnRequestClose={() => handleAvatarModal(false)}
        onSave={saveAvatarImage}
      />

      {(loading || saving) && (
        <Loader className="fixed top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2" />
      )}
    </div>
  );
};

export default BusinessInfo;
